module.exports = __webpack_public_path__ + "img/audit_organizations.50499912.svg";